import React from 'react';
import { createPortal } from 'react-dom';
import Confetti from 'react-confetti';
import { PageHeader } from '@makemydeal/dr-sales-checkin-components';

import { PdfViewer } from '../PdfViewer/PdfViewer';
import { useDealSummaryPdf } from '../../hook/useDealSummaryPdf';
import { useWindowSize } from '../../hook/useWindowSize';
import { AcceptedDealContainer } from './AcceptedDeal.style';
import OfferComments from '../OfferComments/OfferComments';

const AcceptedDeal: React.FC = () => {
    const { showConfetti, onShowConfettiEffect } = useDealSummaryPdf();
    const { width, height } = useWindowSize();

    return (
        <AcceptedDealContainer data-testid="accepted-deal-page">
            {showConfetti &&
                createPortal(
                    <Confetti
                        data-testid="accepted-deal-confetti"
                        recycle={false}
                        numberOfPieces={400}
                        width={width}
                        height={height}
                        style={{ position: 'fixed' }}
                        onConfettiComplete={() => onShowConfettiEffect(false)}
                    />,
                    document.body
                )}
            <PageHeader isResponsive heading="Congratulations! Let's Get You Into Your New Car" />
            <OfferComments />
            <PdfViewer view="acceptedDeal" />
        </AcceptedDealContainer>
    );
};

export default AcceptedDeal;
